interface DeleteAhuPopupProps {
  /** "Delete Air Handling Unit?" / "... Unit Version?" (version rows). */
  isVersion: boolean;
  /** The row's tag (model-name line in the deleted-items list). */
  name: string;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Shared delete confirm (`/static/mvc/view/delete_popup.js` +
 * delete_popup.tmpl — the LIVE `view.delete_popup` path-map resolution,
 * Part A §1). Exact copy (B1.6 / parity 150): title
 * "Delete Air Handling Unit[ Version]?", content "If you choose to Delete,
 * all Air Handling Unit data will be lost and will not be recoverable.",
 * the tag in `.deleted-items`, Delete / Cancel buttons. Esc rides the
 * global popup keys (`button[name=cancel_delete]`), matching the popup's
 * own document Esc listener.
 */
const DeleteAhuPopup = ({ isVersion, name, onConfirm, onClose }: DeleteAhuPopupProps) => (
  <div className="popup-wrapper width-small active">
    <div className="popup-content delete-popup">
      <h2 className="popup-heading">
        Delete Air Handling Unit{isVersion ? ' Version' : ''}?
      </h2>
      <div className="popup-content-part">
        <p>
          If you choose to Delete, all Air Handling Unit data will be lost and
          will not be recoverable.
        </p>
        <ul className="deleted-items">
          <li className="model-name">{name}</li>
        </ul>
      </div>
      <div className="popup-control-buttons">
        <button className="btn right not-highlighted-btn" name="confirm_delete" onClick={onConfirm}>
          Delete
        </button>
        <button
          className="btn right btn_cancel highlighted-btn"
          id="btn_cancel"
          name="cancel_delete"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
);

export default DeleteAhuPopup;
